var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProperties(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47484 10.8357C9.7983 10.5939 11.1588 10.6468 12.4595 10.9907C13.7602 11.3347 14.969 11.9613 15.9998 12.8258C17.0991 11.9064 18.3986 11.2575 19.7939 10.931C21.1893 10.6045 22.6418 10.6096 24.0348 10.9458C22.4328 1.80791 9.56462 1.81154 7.96484 10.9458C8.13199 10.9075 8.30273 10.8659 8.47484 10.8357Z",
    fill: "#674df6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.13 11.6855C7.97432 11.6873 5.90742 12.5444 4.38312 14.0687C2.85883 15.593 2.00172 17.6599 2 19.8156C2.44354 30.6017 17.8181 30.5985 18.26 19.8155C18.2583 17.6598 17.4012 15.5929 15.8769 14.0686C14.3526 12.5444 12.2857 11.6873 10.13 11.6855Z",
    fill: "#674df6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8694 11.6856C19.9965 11.6823 18.181 12.3311 16.7344 13.5206C18.355 15.2156 19.2594 17.4704 19.2594 19.8156C19.2594 22.1607 18.355 24.4155 16.7344 26.1106C18.181 27.3001 19.9965 27.9489 21.8694 27.9456C32.6546 27.5024 32.6533 12.1279 21.8694 11.6856Z",
    fill: "#674df6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProperties);
export default __webpack_public_path__ + "static/media/icon-properties.796fc2c8.svg";
export { ForwardRef as ReactComponent };